<p [class.from-offers]="[GenericCountdownSourceEnum.counteroffer, GenericCountdownSourceEnum.lastOfferEventMsg, GenericCountdownSourceEnum.liveOfferAcceptCountdown].includes(source)"
    *ngIf="countdownMessage.length">
    {{countdownMessage}}
</p>
